export * from './lib/types/tooltip-config.type';
export * from './lib/models/tooltip.model';
export * from './lib/tooltip.module';
